// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Priorities_SalvarResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for POST /so/priorities/salvar
 *
 * Returns the id of the created or updated priority.
 * Wire shape: `dados: { so_priority_id: int }`.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Priorities_SalvarResponseDados {
so_priority_id?: number
}

export type Priorities_SalvarResponse = ApiResponse<Priorities_SalvarResponseDados>;

registerResponseContract('Priorities_SalvarResponse', {
  so_priority_id: { type: 'number',  required: false },
})
